<template>
  <div class="c-checkbox-group">
    <span class="c-checkbox-group__label">{{filters.label}}</span>
    <ul class="c-checkbox-group__list">
      <li
        class="c-checkbox-group__list-item"
        v-for="(item, index) in filters.options"
        v-bind:key="item.id"
      >
        <input
          v-bind:id="index"
          type="checkbox"
          class="c-checkbox-group__list-input visually-hidden"
          v-bind:value="item.value"          
          v-model="checkedNames"
          v-on:change="updateValue"
        >
        <label v-bind:for="index" class="c-checkbox-group__list-label">{{item.label}}</label>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "checkbox",
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      checkedNames: []
    };
  },
  methods: {
    updateValue() {
      this.$eventBus.$emit("updateFilters", this.checkedNames);
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/components/geneco/resources/form/elements/Checkbox.vue